module.exports = __webpack_public_path__ + "static/media/03-03.e99753f1.png";